<template>
		<div class="date-picker-box">
      <div class="dpb-title">{{PackageType==2?'可预约日期':'日期选择'}}
        <div class="closeBtn" @click="cancel">
          <img src="../../../assets/img/close.png">
        </div>
      </div>
			<div class="dpb-week">
				<table>
					<thead>
						<tr>
							<th>日</th>
							<th>一</th>
							<th>二</th>
							<th>三</th>
							<th>四</th>
							<th>五</th>
							<th>六</th>
						</tr>
					</thead>
				</table>
			</div>
			<div class="dpb-week-days">
				<div class="dpbwd-table" v-for="(item,index) in data">
					<div class="dpbwd-table-month">
						{{getMonths(index)}}
					</div>
					<div class="dpbwd-table-items">
						<table class="dpbwd-table-items-table">
							<tbody>
								<tr v-for="week in item">	
									<td :class="day.isActive?'active':(day.isInRange?'range':day.isDisable?'disable':'')" v-for="(day,i) in week" @click="select(day)">
										<div :class="i==0||i==6?'weekcolor page-table-item':'page-table-item'">
											<strong class="page-table-text">
												{{day.day}}
											</strong>
											<em class="page-table-note" v-if="day.item">
												￥{{day.item.Price}}
											</em>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
      <div class="layer" v-if="isAlert">
        <div class="cn-alert">
          <p>{{massage}}</p>
        </div>
      </div>
		</div>

</template>
<script>
export default {
  name: "dailyData",
  data() {
    return {
      data: [],
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      begin: "",
      end: "",
      lastDate: "",
      hDate: "",
      isAlert:false,
      massage:''
    };
  },
  props: {
    monthLength: {
      type: Number,
      default: 3
    },
    beginText: {
      type: String,
      default: "入住"
    },
    endText: {
      type: String,
      default: "离店"
    },
    PackageType: {
      type: Number,
      default: 1
    },
    start: {
      type: Object,
      default: function() {
        return {
          year: this.getDate(0).split("-")[0],
          month: this.getDate(0).split("-")[1],
          day: this.getDate(0).split("-")[2]
        };
      }
    },
    last: {
      type: Object,
      default: function() {
        return {
          year: this.getDate(60).split("-")[0],
          month: this.getDate(60).split("-")[1],
          day: this.getDate(60).split("-")[2]
        };
      }
    },
    handleDate: {
      type: String,
      default: ""
    },
    beginDate: {
      type: Object,
      default: function() {
        return {};
      }
    },
    endDate: {
      type: Object,
      default: function() {
        return {};
      }
    },
    dailyData: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  watch: {
    beginDate(val) {
      this.begin = val;
    },
    endDate(val) {
      this.end = val;
    },
    last(val) {
      this.lastDate = val;
    },
    handleDate(val) {
      this.hDate = val;
      this.tableDate();
    },
    dailyData(val) {
      this.dailyParam();
      this.tableDate();
    }
  },
  methods: {
    //选中日期
    select(day) {
      var that = this
      if(that.PackageType==2){
        that.cancel()
      }else{
        if (!day.isInRange) return;
        that.isAlert = true
        that.massage = "您选择的日期为："+day.item.Date
        setTimeout(()=>{
          that.isAlert = false
          that.$emit("selectday", day.item.Date,day.item);
        },1000)
      }
    },
    cancel() {
      this.$emit("selectday", '');
    },
    //查看是否是已经选中的日期区间中
    isInRange(day) {
      if (!day) return;
      var s1 = new Date(this.begin).getTime();
      var s2 = new Date(this.end).getTime();
      var s = new Date(day.year + "-" + day.month + "-" + day.day).getTime();
      if (s <= s2 && s >= s1) return true;
    },
    //获取天数差
    getDaysSize(s1, s2) {
      var s1 = new Date(s1);
      var s2 = new Date(s2);

      var days = s2.getTime() - s1.getTime();
      var time = parseInt(days / (1000 * 60 * 60 * 24));
      return time;
    },
    //获取周几
    getWeekday(date) {
      var nowDate = new Date();
      var days = this.getDaysSize(nowDate, date);
      var mydate = new Date(date);
      var myday = mydate.getDay(); //注:0-6对应为星期日到星期六
      return myday;
    },

    //将数据格式化表格日期格式
    monthDate(year, month) {
      var that = this
      //或取当前月份最后一天的日期
      var day = new Date(year, month, 0);
      var lastDay = day.getDate();
      //计算当前月份第一天是星期几
      var weekday = that.getWeekday(year + "-" + month + "-01");
      //定义存放当前月份的数组
      var data = [];
      //定义日期表格数组
      var result = [];
      //计算出当前月份每一天到数组中
      for (var day = 1; day <= lastDay; day++) {
        var day = day < 10 ? "0" + day : day;
        var date = year + "-" + month + "-" + day;
        var flag = true;
        var isInRange, isDisable, isActive;
        that.dailyData.forEach(item => {
          if (date == item.Date) {
            flag = false
            if(date == that.hDate&&that.PackageType!=2) {
              isActive = true
            }else {
              isActive = false;
            }
            if(item.isBook){
              isInRange = true;
              isDisable = false;
            }else {
              isInRange = false;
              isDisable = true;
              isActive = false;
            }
            data.push({
              day,
              month,
              year,
              isActive,
              isInRange,
              isDisable,
              item
            });
          }
        });
        if (flag) {
            isActive = false;
            isInRange = false;
            isDisable = true;
            data.push({
              day,
              month,
              year,
              isActive,
              isInRange,
              isDisable,
            });
        }
      }

      //补全日期前几天
      for (var i = 0; i < weekday; i++) {
        data.unshift("");
      }
      //切成6行
      for (var i = 0, len = data.length; i < len; i += 7) {
        result.push(data.slice(i, i + 7));
      }
      //补全日期后几天
      var length = result[result.length - 1].length;
      if (length < 7) {
        for (var i = 0; i < 7 - length; i++) {
          result[result.length - 1].push("");
        }
      }
      return result;
    },
    //初始化表格数据
    tableDate() {
      var monthLength = this.monthLength;
      var data = [];
      // var date = new Date();
      var year = this.year; //获取完整的年份(4位)
      var month = this.month; //获取当前月份
      // console.log(year,month,monthLength)

      for (var i = 0; i < monthLength; i++) {
        var y = month + i > 12 ? year + 1 : year;
        var m = month + i > 12 ? month + i - 12 : month + i;
        var re = this.monthDate(y, m < 10 ? "0" + m : m);
        data.push(re);
      }
      this.data = data;
    },
    dailyParam() {
      var length = this.dailyData.length - 1;
      this.begin = this.dailyData[0].Date;
      this.end = this.dailyData[length].Date;
    }
  }
};
</script>
<style scoped>
.layer {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}
.cn-alert{
  width: 80%;
  position: absolute;
  transform: translate(50%,-50%);
  bottom: 50%;
  right: 50%;
}
.cn-alert p{
  padding:.3rem;
  color: #fff;
  font-size: .34rem;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 0.16rem;
  text-align: center;
}
.weekcolor {
  color: #fb8800 !important;
}
.dpbwd-table-items-table > tbody > tr > td.active .weekcolor {
  color: #fff !important;
}
.date-picker-box {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 24;
}
.dpb-title {
  height: 40px;
  text-align: center;
  line-height: 40px;
  background: #f2f3f4;
  font-size: 15px;
  font-weight: bold;
  position: relative;
}
.closeBtn {
    position: absolute;
    width: 0.5rem;
    right: 0.3rem;
    top: 50%;
    transform: translateY(-50%);
}
.dpb-title > span {
  position: absolute;
  right: 12px;
  line-height: 50px;
  font-size: 13px;
}
.dpb-week > table {
  background: #fff;
  font-size: 13px;
  width: 100%;
  border-collapse: separate;
  table-layout: fixed;
}
.dpb-week > table > thead > tr > th {
  height: 30px;
  text-align: center;
  font-weight: 400;
  /* border-bottom: 1px solid #e0e0e0; */
  width: 14.28571%;
  vertical-align: middle;
}
.dpb-week-days {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-bottom: 120px;
}
.dpbwd-table-month {
  height: 30px;
  display: -webkit-box;
  -webkit-box-align: center;
  -webkit-box-pack: center;
  font-size: 15px;
  font-weight: 700;
  background: hsla(210, 8%, 95%, 0.9);
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1;
  /* border-bottom: 1px solid #e0e0e0; */
}
.page-table-item {
  box-sizing: border-box;
  position: relative;
  /*display: -webkit-box;*/
  -webkit-box-orient: vertical;
  -webkit-box-align: center;
  -webkit-box-pack: end;
}
.page-table-text {
  font-size: .3rem;
  font-weight: bold;
  margin-bottom: 0.1rem;
}
.page-table-note {
  color: #fb8800;
  font-size: .24rem;
  font-style: inherit;
}
.active .page-table-note {
  color: #fff;
}
.page-table-note,
.page-table-text {
  display: block;
  width: 100%;
  text-align: center;
  height: 15px;
  line-height: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dpbwd-table-items-table > tbody > tr > td.disable .page-table-text,
.dpbwd-table-items-table > tbody > tr > td.disable .page-table-note {
  color: #ccc !important;
  background: none !important;
}
.dpbwd-table-items-table > tbody > tr > td.range {
  background: #e8f4ff;
  /* border-bottom-color: #e8f4ff !important; */
}
.dpbwd-table-items-table > tbody > tr > td.active {
  color: #fff;
  background: #2391ff;
  /* border-bottom-color: #2391ff !important; */
}
.dpbwd-table-items-table > tbody > tr > td.disable {
  background: #fafafa !important;
  /* border-bottom-color: #e0e0e0 !important; */
}
.dpbwd-table-items-table > tbody > tr > td {
  height: 60px;
  text-align: center;
  width: 14.28571%;
  position: relative;
  /* border-bottom: 1px solid #e0e0e0; */
}
.dpbwd-table-items-table {
  width: 100%;
  border-collapse: separate;
  table-layout: fixed;
}

</style>



// WEBPACK FOOTER //
// src/components/free/cmpnt/dailyData.vue